import uniqBy from 'lodash/uniqBy';
import moment from 'moment';
import 'moment-timezone';
import { fromIso9075DateString, getIso9075DateString } from 'utils/dates';
import { REWARD_TYPE } from 'utils/rewards';
import UberIcon from 'resources/icon-uber.png';
import WindCreekW from 'resources/WindCreekW.png';
import Label_CasinoTickets from './assets/icons/Label_CasinoTickets.png';
import Label_Coupon from './assets/icons/Label_Coupon.png';
import Label_DrawingTickets from './assets/icons/Label_DrawingTickets.png';
import Label_Entertainment from './assets/icons/Label_Entertainment.png';
import Label_Food from './assets/icons/Label_Food.png';
import Label_FreeDrink from './assets/icons/Label_FreeDrink.png';
import Label_FreePlay from './assets/icons/Label_FreePlay.png';
import Label_Hotel from './assets/icons/Label_Hotel.png';
import Label_Merchandise from './assets/icons/Label_Merchandise.png';
import Label_Spa from './assets/icons/Label_Spa.png';
import Label_WScore from './assets/icons/Label_WScore.png';

export function getDateTime(value) {
  return moment.utc(fromIso9075DateString(value)).local();
}

export function formatDateTime(value) {
  return value.format('ddd MMMM D YYYY hh:mm A');
}

export function formatDateTimeToServer(value) {
  return getIso9075DateString(value);
}

export const categoryToImage = category => {
  switch (category) {
    case 'K - Casino Ticket':
      return Label_CasinoTickets;
    case 'U - Coupon':
    case 'D - Coupon':
      return Label_Coupon;
    case 'D - Ticket':
      return Label_DrawingTickets;
    case 'D - Entertainment':
      return Label_Entertainment;
    case 'F - Food and Beverage':
      return Label_Food;
    case 'F - Free Drink':
      return Label_FreeDrink;
    case 'G - Electronic promo Credit to Machine':
      return Label_FreePlay;
    case 'H - Room':
      return Label_Hotel;
    case 'U - Merchandise':
      return Label_Merchandise;
    case 'S - Spa':
      return Label_Spa;
    case 'WScore':
      return Label_WScore;
    case REWARD_TYPE.PARTNERS:
      return UberIcon;
    default:
      return Label_Merchandise;
  }
};

export const categoryToIcon = item => {
  const { category, url } = item;
  if (url) return url;

  switch (category) {
    case REWARD_TYPE.PARTNERS:
      return UberIcon;
    default:
      return WindCreekW;
  }
};

export const getUniquePrizes = prizes => {
  return prizes
    ? uniqBy(
        prizes.filter(p => p.url || p.category === REWARD_TYPE.PARTNERS),
        'url'
      )
    : [];
};
